import { z } from "zod";
import { ulidSchema } from "./schemas.js";
/**
 * Where a book in My Library has got to, in one vocabulary for every kind of book (redesign
 * Stage 2, F2). The server reads it from the records each step leaves behind; it is a guide to
 * the next step, never an approval or a promise.
 *
 * - TELLING: the story is still being told; nothing is laid out yet.
 * - PICTURES: the pages are laid out and the pictures are being made.
 * - REVIEW: the whole book is made and waits to be read and approved.
 * - APPROVED: the book is approved as it stands.
 * - ORDERED: a printed copy was ordered from the approved book.
 */
export const libraryBookStepSchema = z.enum([
    "TELLING",
    "PICTURES",
    "REVIEW",
    "APPROVED",
    "ORDERED",
]);
/**
 * What to do next, and where. REOPEN is the reopen-after-approval model's own action (F4): this
 * list never chooses it by itself.
 */
export const libraryNextActionKindSchema = z.enum([
    "CONTINUE",
    "REVIEW",
    "PRINT",
    "READ",
    "REOPEN",
]);
export const libraryBookProgressSchema = z
    .object({
    step: libraryBookStepSchema,
    /** Absent when this reader has nothing to do with the book yet (a viewer of a book in making). */
    nextAction: z
        .object({
        kind: libraryNextActionKindSchema,
        /** A page in the app: the book's own steps, its print review, or My Library to read it. */
        path: z
            .string()
            .max(300)
            .regex(/^\/app(?:[/?]|$)/u),
    })
        .strict()
        .optional(),
    /** The latest change any step recorded: a book's own record isn't touched as it progresses. */
    changedAt: z.string().datetime().optional(),
    /**
     * The book's last step stopped before it finished, and nothing carries on until the book is
     * opened again (a Bedtime step to try again, B6 2026-11-02). Absent while all is well.
     */
    stopped: z.literal(true).optional(),
})
    .strict();
/** A reader's page in a book, as My Library's reader numbers it: 0 is the cover. */
export const libraryReadingPageSchema = z.number().int().min(0).max(400);
/** "Continue from page" (F7): the page this reader left a book at, kept for each book. */
export const readingPositionCommandSchema = z.object({ page: libraryReadingPageSchema }).strict();
export const readingPositionResponseSchema = z
    .object({
    data: z.object({ bookId: ulidSchema, page: libraryReadingPageSchema }).strict(),
})
    .strict();
//# sourceMappingURL=library-progress.js.map